import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeroSection from './sections/HeroSection';
import WorkflowSection from './sections/WorkflowSection';
import PlaygroundSection from './sections/PlaygroundSection';
import BentoGridSection from './sections/BentoGridSection';
import './LandingPage.css';

const LandingPage = () => {
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target); // Optimize: Stop observing once visible
                }
            });
        }, { threshold: 0.15 });

        const sections = document.querySelectorAll('.fade-in-section');
        sections.forEach(section => observer.observe(section));

        return () => observer.disconnect();
    }, []);

    return (
        <div className="landing-page">
            <header className="lp-brand-header">
                <h1 className="lp-brand-text">ALEKHINE AI</h1>
            </header>
            <Link to="/login" className="lp-login-btn-fixed">Login</Link>
            <HeroSection />
            {/* <WorkflowSection /> */}
            <PlaygroundSection />
            {/* <BentoGridSection /> */}

            <footer className="lp-footer">
                <div className="lp-footer-content">
                    <p>&copy; 2026 AlekhineAI. All rights reserved.</p>
                    <p style={{ fontSize: '0.5rem', opacity: 0.7 }}>*All media is AI generated.</p>
                </div>
            </footer>
        </div >
    );
};

export default LandingPage;
